import { getAllRoles } from '../../../../../../../../../crud/configuration_api/roles';
import { RoleOption, PuestoOption } from '../types';
import { getPuestosByLocalId } from '../../../../../../../../../crud/management_api/puestos';


export const getRolesOptions = async () => {
  const response = await getAllRoles();
  if (response) {
    const data = response.data;
    if (data) {
      const roles: RoleOption[] = data.map((rol: any) => {
        return {
          id: rol.rol_id,
          name: rol.rol_name,
          description: rol.rol_description || "Sin descripción",
        };
      });
      return roles;
    }
  }
  return [];
};

export const getPuestosOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getPuestosByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const puestos: PuestoOption[] = data.map((puesto: any) => {
        return {
          id: puesto.puesto_id,
          name: puesto.puesto_name,
          description: puesto.puesto_description,
        };
      });
      return puestos;
    }
  }
  return [];
};
